import { z } from "zod";
import { baseSearchSchema } from "../-search-params";

export const cosmeticSearchSchema = z.object({
	...baseSearchSchema.shape,
});

export type CosmeticSearch = z.infer<typeof cosmeticSearchSchema>;

export const validateCosmeticSearch = (search: Record<string, unknown>): CosmeticSearch => {
	return cosmeticSearchSchema.parse(search);
};
